<div class="upper_footer_section">
  <div class="section_column">
    <div class="footer_section_header">
      Company
    </div>
    <a
      class="footer_item"
      target="_blank"
      href="https://www.globalaccelerex.com/about"
    >
      About Us
    </a>
    <!-- <div class="footer_item" routerLink="../services">
      Services
    </div> -->
    <a
      class="footer_item"
      target="_blank"
      href="https://www.globalaccelerex.com/partners"
    >
      Partners
    </a>
    <a
      class="footer_item"
      target="_blank"
      href="https://www.globalaccelerex.com/solutions"
    >
      Solutions
    </a>
    <!-- <div class="footer_item">
      Blog
    </div>  -->
  </div>
  <div class="section_column">
    <div class="footer_section_header">
      RexHub
    </div>
    <!-- <div class="footer_item">
      About
    </div> -->
    <a class="footer_item" routerLink="../faqs">
      F.A.Q
    </a>
    <a class="footer_item" routerLink="../privacy-policy">
      Privacy Policy
    </a>
    <a class="footer_item" routerLink="../terms-of-use">
      Terms of Use
    </a>
  </div>
  <div class="section_column">
    <div class="footer_section_header">
      Contact
    </div>
    <div class="footer_item">
      No. 8, Eric Moore Street, <br />
      Wemabod Estate, <br />
      Ikeja - Lagos Nigeria
    </div>

    <a class="footer_item" href="mailto:rexhub@globalaccelerex.com">
      rexhub&#64;globalaccelerex.com
    </a>
    <div class="social">
      <a
        href="https://www.instagram.com/globalaccelerex"
        class="fa fa-instagram"
        target="_blank"
      ></a>
      <a
        href="https://twitter.com/GlobalAccelerex

      "
        target="_blank"
        class="fa fa-twitter-square"
      ></a>
      <a
        href="
      https://www.facebook.com/globalaccelerex"
        target="_blank"
        class="fa fa-facebook-square"
      ></a>
    </div>
  </div>
</div>

<div class="lower_section_footer">
  <i class="fa fa-copyright"></i> Global Accelerex {{ currentYear }}
</div>
